<template>
  <div class="mobileOta">
    <div class="title">雷鸟Air 固件升级</div>
    <div class="content">
      <img src="../../assets/images/mobileFrame.png" alt="" />
      <div class="desc">暂不支持移动端固件升级</div>
    </div>

    <div class="tips">
      <div class="line"></div>
      <div class="t">请在电脑上使用以下浏览器进行固件升级</div>
      <div class="line"></div>
    </div>

    <div class="items">
      <div class="item">
        <img src="../../assets/images/google.png" alt="" />
        <div class="label">Google</div>
        <div class="num">版本号大于89</div>
      </div>
      <div class="item">
        <img src="../../assets/images/opera.png" alt="" />
        <div class="label">Opera</div>
        <div class="num">版本号大于76</div>
      </div>
      <div class="item">
        <img src="../../assets/images/edge.png" alt="" />
        <div class="label">Edge</div>
        <div class="num">版本号大于89</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.mobileOta {
  width: 100%;
  padding: 42px 24px;
  box-sizing: border-box;

  .title {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
  }

  .content {
    background: rgba(252, 252, 253, 1);
    border: 0.76px solid rgba(242, 243, 249, 1);
    border-radius: 0.76px;
    padding: 38px 0px 38px 0px;
    width: 327px;
    height: 238px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    margin-left: 50%;
    transform: translateX(-50%);

    img {
      width: 267px;
      height: 109px;
    }

    .desc {
      font-size: 18px;
      font-weight: 500;
      line-height: 36.67px;
      text-align: center;
      margin-top: 16px;
    }
  }

  .tips {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 36px;

    .t {
      font-size: 14px;
      font-weight: 400;
      line-height: 23.8px;
      margin: 0 2px;
      color: rgba(101, 101, 101, 1);
    }

    .line {
      width: 32px;
      height: 1px;
      background-color: rgba(229, 230, 235, 1);
    }
  }

  .items {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    .item {
      margin-right: 20px;

      &:last-child {
        margin-right: 0px;
      }

      img {
        width: 60px;
        height: 60px;
      }

      .label {
        font-size: 12px;
        font-weight: 500;
        line-height: 20.4px;
        text-align: center;
        color: rgba(80, 80, 80, 1);
      }

      .num {
        font-size: 8px;
        font-weight: 400;
        line-height: 13.6px;
        text-align: center;
        color: rgba(130, 130, 130, 1);
      }
    }
  }
}
</style>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
